// export { ProjectNavElement } from "@flightpath/coreui/dist/ui/ProjectNavElement";
import React from "react";
import { Link } from "react-router-dom";
import { B } from "../../../core/util/BootstrapHelper";
import { UiSizes } from "../../../enums";
import { Icon, IconSymbols } from "../../ui/Icon";
import { ProcessPages } from "../../../apps/processes/routes/pages";
import { ChangePages } from "../../../apps/change/routes/pages";
import { TrainingPages } from "../../../apps/training/routes/pages";
import processesIcon from "../../../components/widgets/navigation/icons/step.svg";
import stakeholdersIcon from "../../../components/widgets/navigation/icons/person_heart.svg";
import audiencesIcon from "../../../components/widgets/navigation/icons/groups.svg";
import impactsIcon from "../../../components/widgets/navigation/icons/local_fire_department.svg";
import actionsIcon from "../../../components/widgets/navigation/icons/checklist.svg";
import trainingIcon from "../../../components/widgets/navigation/icons/school.svg";

export interface ProjectNavElementProps {
  name: string;
  url: string;
  organisationId: string | number;
  projectId: string | number;
  hasImpactsAccess?: boolean;
  hasActionsAccess?: boolean;
  hasStakeholdersAccess?: boolean;
  hasProcessAccess?: boolean;
  hasTrainingAccess?: boolean;
}

const ActiveIcon: React.FC<any> = ({ className, url, icon }) => (
  <Link className={className} to={url}>
    {icon}
  </Link>
);

const InactiveIcon: React.FC<any> = ({ className, icon }) => <div className={className}>{icon}</div>;

export const NavIcon: React.FC<any> = ({ hasAccess, className, url, icon }) => {
  if (hasAccess) {
    return <ActiveIcon className={`${className} project-nav-element__icon--active`} url={url} icon={icon} />;
  }
  return <InactiveIcon className={`${className} project-nav-element__icon--inactive`} icon={icon} />;
};

export const ProjectNavElement: React.FC<ProjectNavElementProps> = ({
  name,
  organisationId,
  projectId,
  hasImpactsAccess,
  hasActionsAccess,
  hasStakeholdersAccess,
  url
}) => {
  const cls: string = B().bl("project-nav-element").bem;
  return (
    <div className={`${cls}`}>
      <Link to={url} style={{ flex: 1 }}>
        <div className="project-nav-element__name">
          <p className="mb-0">{name}</p>
        </div>
      </Link>
      <div className="project-nav-element__icons">
        <NavIcon
          className="project-nav-element__icon mr-1"
          hasAccess={true}
          url={url}
          icon={<Icon symbol={IconSymbols.Projects} size={UiSizes.SM} />}
        />
        <NavIcon
          className="project-nav-element__icon mr-1"
          hasAccess={true}
          url={ProcessPages.reports.generateLink(organisationId, projectId)}
          icon={<img src={processesIcon} alt="Processes" width={16} height={16} />}
        />
        <NavIcon
          className="project-nav-element__icon mr-1"
          hasAccess={!!hasStakeholdersAccess}
          url={ChangePages.stakeholders.visualisations.index.generateLink(organisationId, projectId)}
          icon={<img src={stakeholdersIcon} alt="Stakeholders" width={16} height={16} />}
        />
        <NavIcon
          className="project-nav-element__icon mr-1"
          hasAccess={!!hasStakeholdersAccess}
          url={ChangePages.audiences.visualisations.index.generateLink(organisationId, projectId)}
          icon={<img src={audiencesIcon} alt="Audiences" width={16} height={16} />}
        />
        <NavIcon
          className="project-nav-element__icon mr-1"
          hasAccess={!!hasImpactsAccess}
          url={ChangePages.impacts.visualisations.impactAssesment.generateLink(organisationId, projectId)}
          icon={<img src={impactsIcon} alt="Impacts" width={16} height={16} />}
        />
        <NavIcon
          className="project-nav-element__icon mr-1"
          hasAccess={!!hasActionsAccess}
          url={ChangePages.actions.visualisations.index.generateLink(organisationId, projectId)}
          icon={<img src={actionsIcon} alt="Actions" width={16} height={16} />}
        />
        <NavIcon
          className="project-nav-element__icon mr-1"
          hasAccess={true}
          url={TrainingPages.learningDashboard.generateLink(organisationId, projectId)}
          icon={<img src={trainingIcon} alt="Training" width={16} height={16} />}
        />
      </div>
    </div>
  );
};
